// extracted by mini-css-extract-plugin
export default {"title":"search_facets_lib-module__title--2Yr8P"};